import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const useInitGtm = () => {
  useEffect(() => {
    if (process.env.REACT_APP_GTM_ID) {
      TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
    } else {
      console.log('GTM id not set');
    }
  }, []);
};
